import { useTranslation } from 'react-i18next';

export const InfoTypes = (invoice) => {
  const { t } = useTranslation();

  const typeCodeMap = {
    326: t('Partial Invoice'),
    380: t('Invoice'),
    381: t('Credit Note'),
    384: t('Corrected Invoice'),
    389: t('Self Billed Invoice'),
    875: t('Partial Construction Invoice'),
    876: t('Partial Final Construction Invoice'),
    877: t('Final Construction Invoice'),
  };

  const infosDefault = [
    {
      label: t('Nr'),
      value: invoice.nr ?? t('Draft'),
    },
    {
      label: t('Date'),
      value: invoice.date,
      type: 'date',
    },
    {
      label: t('Source'),
      value: t(invoice.sourceType),
    },
  ];
  const infosOrder = [
    {
      label: t('Order Nr'),
      value: invoice.source && invoice.source.nr,
    },
  ];
  const infosContract = [
    {
      label: t('Contract Nr'),
      value: invoice.source && invoice.source.nr,
    },
  ];

  const type = [
    {
      label: t('Type'),
      value: invoice.typeCode ? typeCodeMap[invoice.typeCode] : t('Invoice'),
    },
  ];

  const typeMap = {
    order: [...infosDefault, ...infosOrder, ...type],
    contract: [...infosDefault, ...infosContract, ...type],
    custom: [...infosDefault, ...type],
  };

  return typeMap[invoice.sourceType];
};
